<template>
  <div class="full-screen" style="height: 100%; z-index: 1;">
    <div class="topbar flex">
      <div class="fl">
        <a @click="returnPage">
          <i class="fa-angle-left"></i>
        </a>
      </div>
      <div class="span-title">充值中心</div>
      <a class="lk-home" @click="returnHome">
        <i class="fa-home"></i>
      </a>
    </div>

    <div class="scroll-list" style="padding-top: 2.5rem;">

      <!-- <div class="my-title bg-r" style="padding-top: 2rem;">
        <div class="content">
          <img src="../../../assets/images/user.png" class="content-l">
          <div class="content-r">
            <p class="username">
              {{purchaseInfo.userInfo.account}}
              <img v-if="purchaseInfo.userInfo.vipType === 'none'" src="../../../assets/images/icon-vip2.png"/>
              <img v-else src="../../../assets/images/icon-vip.png"/>
            </p>
            <p class="userid">密码: {{purchaseInfo.userInfo.password}}</p>
          </div>
          <div class="yj">永久域名：xabmh.com<span @click="copyUrl('http://xabmh.com')">复制</span></div>
        </div>
      </div> -->


      <div class="bd-content">

        <div class="c-top">
          <div class="c-top-i">
            <p>
              <span class="f12">剩余金币</span>
              <span class="f14">{{ purchaseInfo.availableAmount }}</span>
            </p>
          </div>
          <div class="c-top-i">
            <p v-if="purchaseInfo.userInfo.vipType === 'none'">
              <span class="f12">未开通VIP</span>
              <span class="f10"> --</span>
              <!-- <span class="btn">去开通</span> -->
            </p>
            <p v-else>
              <span class="f12">到期时间</span>
              <span class="f10">{{ purchaseInfo.userInfo.vipEndDate }}</span>
            </p>
          </div>
        </div>


        <div class="buy-vip">
          <div v-for="(item, index) in purchaseInfo.payConfigs.filter(i => i.type === 'vip')" :key="'vip-' + index"
               @click="chooseType(item.amountLevel, 'vip', item.title)"
               :class="['billboards', {'active': item.isDefault === 'Y'}]">
            <div class="bg"></div>
            <div class="f1">购买 VIP{{ item.title }}</div>
            <div class="f2" v-if="item.presentType === 'vip'">{{ item.configDesc }} +
              送<strong>{{ item.presentCount }}</strong>天
            </div>
            <div class="f2" v-else>{{ item.configDesc }} + 送<strong>{{ item.presentCount }}</strong>金币</div>
            <button @click="chooseType(item.amountLevel, 'vip', item.title)" class="btn">¥{{ getPriceText(item.amountLevel) }}
            </button>
          </div>
        </div>

        <div class="paybox">
          <h4>金币充值（永久有效）</h4>
          <ul class="payul">
            <li v-for="(item, index) in purchaseInfo.payConfigs.filter(i => i.type === 'coin')" :key="'coin' + index"
                :class="['choose-block', {'active': item.isDefault === 'Y'}]">
                <a class="ov" @click="chooseType(item.amountLevel, 'coin', Math.floor(item.itemCount) + Math.floor(item.presentCount) )">
                <p class="f16"><strong>{{ item.itemCount + item.presentCount }}</strong> 金币</p>
                <p class="f12"><strong>¥ {{ getPriceText(item.amountLevel) }}</strong>元</p>
                <p class="f14"><span>{{ item.itemCount }} +送 {{ item.presentCount }}</span></p>
                <p class="tage_name" v-if="item.isRecommend === 'Y'">热销</p>
              </a>
            </li>
          </ul>
        </div>


        <div class="pay-txt">
          <p>1.请妥善保管您的登录账号和密码<span v-if="!inWebView">，建议您<a v-show="inAndroidBrowser"
                                                            @click="downloadAndroidApp">下载APP</a><a
            v-show="inIosBrowser" @click="inIosBrowserStep=true">添加到桌面</a>并登录此账号</span>；</p>
          <p>2.本平台销售均为虚拟商品，一经交易无法退款处理；</p>
          <p style="color:#4CAF50">3.全站漫画阅读金币只收一次费，再次阅读免费(开通VIP全站免费)</p>
          <p>4.如果<span style="color:red">充值成功未到账</span>，请及时联系客服进行处理，我们将在第一时间为您处理；</p>
          <p>5.<span style="color:red">找回充值账户</span>可以通过支付的商户订单号找回您的账户。</p>
          <p><a :href="this.imUrl"><strong>点此联系客服</strong></a>（工作时间：11:00 ~ 18:00）</p>
        </div>

        <div class="btnbox-p charge" style=" ">
          <button type="button" class="btn btn-pay" @click="openChoosePay">立即充值</button>
        </div>

      </div>
    </div>

    <div v-show="inIosBrowserStep" class="add-icon">
      <div class="dialog-bottom row">
        <div class="dialog-down"></div>
        <span class="cc">请点击</span>
        <span class="cc"><img class="img" src="../../../assets/img/icon-20.png"></span>
        <span class="cc">然后点击“添加到主屏幕”</span>
      </div>
      <div class="dialog-mask" @click="inIosBrowserStep=false"></div>
    </div>

    <div id="payDialogMask" class="mask" @click="closeChoosePay"></div>

    <div id="choosePayContainer" class="popupbox">
      <div class="popup-title">
        <h4 v-if="selected.purpose === 'vip'">充值VIP：<strong>{{ selected.amount / 100 }}元 = {{ popsTitle }}</strong></h4>
        <h4 v-else>充值金币：<strong>{{ selected.amount / 100 }}元 = {{ popsTitle }}金币</strong></h4>
  
        <p>充值账号：<strong style="color: #4CAF50;">{{ purchaseInfo.userInfo.account }}</strong> / 密码:<strong style="color: #4CAF50;">{{ purchaseInfo.userInfo.password }}</strong></p>
        <p class="c-red">请务必截图保存账户密码</p>

        <p class="c-red">请务必截图保存账户密码</p>
      </div>
      <div class="popup-paybox">
        <dl v-for="(item, index) in this.purchaseInfo.subTypes" :key="'subType-' + index"
            :class="[{'btn-ali' : item.superiorCode === 'alipay'}, {'btn-wx' : item.superiorCode === 'wechat_pay'}]"
            @click="choosePayChannel(item.subTypeCode, item.superiorCode, item.initiatorCode)">
          <dt>
            <i
              :class="[{'ali-icon' : item.superiorCode === 'alipay'}, {'wx-icon' : item.superiorCode === 'wechat_pay'}, {'bank-icon' : item.superiorCode === 'bank'}]"></i>
            <span class="pay-type">{{ item.subTypeDesc }}</span>
            <span class="discount" v-if="item.discount < 10">{{ item.discount }}折</span>
          </dt>
        </dl>
        <dl v-if="this.purchaseInfo.subTypes ==undefined || this.purchaseInfo.subTypes.length == 0">
          <dt>
            <span><strong>充值通道维护中......<a :href="this.imUrl">联系客服<!--代充--></a></strong></span>
          </dt>
        </dl>
      </div>
      <div class="popup-notice">
        <span>金币与VIP均为虚拟商品，购买成功概不退货，敬请谅解</span>
        <span>充值遇到问题？<a :href="this.imUrl"><strong>点此联系客服</strong></a><!--（代充）--></span>
      </div>
    </div>

    <!-- <a id="purchaseReportUrl" class="fixed-ts" style="z-index: 10"><span>投诉</span></a> -->

    <div id="payDeadlineAlert-modal" v-show="payDeadlineAlert" class="fixed-confirm" style="display: block;">
      <div class="fixed-c paypage">

        <div class="find-success">
          <h5>请务必在<strong>2分钟以内</strong>完成支付！</h5>
          <p>如果实际支付时间超过2分钟，则充值后可能无法到帐,</p>
          <p>如果支付时不确定是否超时，请返回本页面重新发起支付。</p>
        </div>
        <div class="btnbox">
          <button class="btn" type="button" @click="charge">确认支付</button>
          <button class="btn" type="button" @click="hidePayDeadlineAlert" style="opacity: .5;">取消</button>
        </div>
      </div>
    </div>

    <alert :show="showAlert" :msg="alertMsg" @hided="showAlert = false"></alert>

  </div>
</template>

<script>
import userService from "../../../services/userService";
import payService from "../../../services/payService";
import {Kkconfig} from "../../../assets/js/config";
import commService from "../../../services/commService";
import kkUtil, {payKey} from "../../../assets/js/kk-util";
import nativePay from "../../../assets/js/native-pay";
import {getReportUrl, StaticApiBase} from "../../../services/urlService";
import Alert from "../../../components/share/alert";

export default {
  name: "purchase",
  data() {
    return {
      popsTitle: '',
      payPurposeId: '',
      payDeadlineAlert: false,
      purchaseInfo: {
        userInfo: {},
        payConfigs: [],
        subTypes: [],
        availableAmount: 0
      },
      selected: {
        purposeId: '',
        amount: 0,
        purpose: '',
        payChannel: '',
        superiorCode: '',
        initiatorCode: ''
      },
      commInfo: {},
      // inBrowser:true,
      // clientType:'ios',
      appType: 'wap_browser',
      imUrl: '',
      showAlert: false,
      alertMsg: '',
      inWebView: false,
      inAndroidBrowser: false,
      inIosBrowser: false,
      inIosBrowserStep: false
    }
  },
  methods: {
    returnPage() {
      this.$router.isBack = true;
      this.$router.go(-1);
    },
    returnHome() {
      this.$router.isBack = false;
      this.$router.push('/home');
    },
    getPriceText(amount) {
      return parseFloat(amount / 100);
    },
    /**
     * 选择支付方案
     */
    chooseType(amount, purpose, title) {
      this.popsTitle = title
      this.selected.amount = parseInt(amount);
      this.selected.purpose = purpose;
      let liBlocks = document.getElementsByClassName("choose-block");
      for (let i = 0; i < liBlocks.length; i++) {
        liBlocks[i].className = "choose-block";
      }
      let liBlocks2 = document.getElementsByClassName("billboards");
      for (let i = 0; i < liBlocks2.length; i++) {
        liBlocks2[i].className = "billboards";
      }
      this.openChoosePay();
    },
    /**
     * 选择通道
     */
    choosePayChannel(payChannel, superiorCode, initiatorCode) {
      this.selected.payChannel = payChannel;
      this.selected.superiorCode = superiorCode;
      this.selected.initiatorCode = initiatorCode;
      this.closeChoosePay();
      //同时打开提示框
      this.payDeadlineAlert = true;
    },
    hidePayDeadlineAlert() {
      this.payDeadlineAlert = false;
    },
    charge() {
      this.payDeadlineAlert = false;
      let vueReturnUrl = window.location.protocol + "//" + window.location.host;
      let ts = new Date().getTime();
      let originStr = "rechargerAmount=" + this.selected.amount +
        "&payChannel=" + this.selected.payChannel +
        "&userId=" + userService.getLocalUserInfo().userId +
        "&ts=" + ts;
      let chargePara = "?rechargerAmount=" + this.selected.amount + "&payPurposeId=" + this.payPurposeId +
        "&payChannel=" + this.selected.payChannel + "&payPurpose=" + this.selected.purpose +
        "&userId=" + userService.getLocalUserInfo().userId + "&branchId=" + userService.getBranchId() +
        "&fromDomain=" + userService.getLocalUserFrom() + "&appType=" + this.appType +
        "&vueReturnUrl=" + vueReturnUrl + "&dynamicApiUrl=" + Kkconfig.reqUrl.dynApiUrl +
        "&ts=" + ts + "&random=" + kkUtil.e(originStr);
      // let payUrl = Kkconfig.reqUrl.payUrl + "/h5/pay/apply" + chargePara;
      let payUrl = "/h5/pay/apply" + chargePara;
      if (this.selected.initiatorCode === "wap_pay") {
        //this.$router.push({name: 'user-purchase-pay', params: {goUrl: payUrl}});
        window.location.href = payUrl;
      } else {
        //app支付，那么需要和原生的app进行交互
        payService.applyPay(payUrl)
          .then(res => {
            if (res.result) {
              if (this.selected.superiorCode === "wechat_pay") {
                nativePay.wechatAppPay(res.data);
              } else {
                nativePay.alipayAppPay(res.data, vueReturnUrl);
              }
            }
          })
      }
    },
    getPurchaseInfo() {
      payService.getPurchaseInfo(this.appType)
        .then(res => {
          this.purchaseInfo = res.data;
          if (this.purchaseInfo.payConfigs) {
            for (let i = 0; i < this.purchaseInfo.payConfigs.length; i++) {
              let item = this.purchaseInfo.payConfigs[i];
              if (item.isDefault == "Y") {
                this.selected.amount = item.amountLevel;
                this.selected.purpose = item.type;
                this.selected.initiatorCode = item.initiatorCode;
                if(item.presentType === 'coin'){
                  this.popsTitle = Math.floor(item.itemCount) + Math.floor(item.presentCount)
                }else if(item.presentType === 'vip'){
                  this.popsTitle = item.title
                }
              }
            }
          }
          //老的用户被删了，那么就以新的用户为准
          let localUser = userService.getLocalUserInfo();
          if (typeof (localUser) == "undefined" || localUser == null) {
            userService.updateLocalUserInfo(this.purchaseInfo.userInfo);
          } else {
            if (localUser.userId != this.purchaseInfo.userInfo.userId) {
              userService.updateLocalUserInfo(this.purchaseInfo.userInfo);
            }
          }
          this.imUrl = Kkconfig.reqUrl.imUrl + "?account=" + this.purchaseInfo.userInfo.account;
          document.getElementById("purchaseReportUrl").href = getReportUrl(this.purchaseInfo.userInfo.account);
        })
    },
    showAddContainer() {
      let container = document.getElementById("addScreenContainer");
      container.style.display = 'block';
    },
    hideAddContainer() {
      let container = document.getElementById("addScreenContainer");
      container.style.display = 'none';
    },
    openChoosePay() {
      let payDialogMask = document.getElementById("payDialogMask");
      payDialogMask.style.display = 'block';
      let payContainer = document.getElementById("choosePayContainer");
      payContainer.style.display = 'block';
    },
    closeChoosePay() {
      let payDialogMask = document.getElementById("payDialogMask");
      payDialogMask.style.display = 'none';
      let payContainer = document.getElementById("choosePayContainer");
      payContainer.style.display = 'none';
    },
    openQQ(position) {
      userService.openQQ(this.commInfo.customerServiceQQ, position);
    },
    openEmail(position) {
      userService.openEmail(this.commInfo.customerServiceEmail, position);
    },
    downloadAndroidApp() {
      window.location.href = commService.getLocalInitData().appDownloadUrl;
    },
    getStaticApiUrl(path) {
      return `${StaticApiBase}${path}`;
    },
    copyUrl(url) {
      (function () {
        document.oncopy = function (e) {
          e.clipboardData.setData('text', url)
          e.preventDefault();
          document.oncopy = null;
        }
      })(url);
      document.execCommand('Copy');
      this.alertMsg = '复制成功';
      this.showAlert = true;
    }
  },
  components: {
    alert: Alert
  },
  mounted() {
    this.payPurposeId = this.$route.query.bookId;
    if (!this.payPurposeId || this.payPurposeId == "undefined") {
      this.payPurposeId = '';
    }
    this.$router.isBack = true;
    this.commInfo = commService.getLocalInitData();

    this.inWebView = kkUtil.isInWebView();
    this.inAndroidBrowser = kkUtil.isInAndroidBrowser();
    this.inIosBrowser = kkUtil.isInIosBrowser();

    //服务端需要的appType
    if (this.inWebView) {
      this.appType = 'shell'
    } else if (navigator.standalone) {
      this.appType = 'ios_desk';
    } else if (this.inAndroidBrowser || this.inIosBrowser) {
      this.appType = 'wap_browser';
    } else {
      this.appType = 'other'
    }

    // this.inBrowser = !kkUtil.isInWebView();
    // this.clientType = kkUtil.getClientType();
    // if(this.inBrowser){
    //   if(navigator.standalone){
    //     this.appType = "ios_desk";
    //   }
    // }else {
    //   if(this.clientType == "android"){
    //     this.appType = "shell";
    //   }else {
    //     this.appType = "other";
    //   }
    // }

    //根据是否已经有token判断何时调用支付接口
    let currUser = userService.getLocalUserInfo();
    if (!currUser) {
      userService.register()
        .then(res => {
          if (res.result) {
            this.getPurchaseInfo();
          }
        })
    } else {
      //直接调用即可
      this.getPurchaseInfo();
    }

    payService.setPayPageHistory();
  },
  watch: {
    purchaseInfo: function () {
      this.$nextTick(function () {
        let liBlocks = document.getElementsByClassName("choose-block");
        for (let i = 0; i < liBlocks.length; i++) {
          liBlocks[i].addEventListener("click", function (e) {
            liBlocks[i].className = "active choose-block";
          });
        }
        let liBlocks2 = document.getElementsByClassName("billboards");
        for (let i = 0; i < liBlocks2.length; i++) {
          liBlocks2[i].addEventListener("click", function (e) {
            liBlocks2[i].className = "active billboards";
          });
        }
      });
    }
  }
}
</script>

<style scoped>
.fixed {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}


.top {
  position: fixed;
  top: 0;
  width: auto;
  background-color: transparent;
  padding: 8px 0;
  color: #333333;
  font-weight: bold;
}

.top .back {
  padding: 0 1.5rem;
  position: relative;
}

.top .back:before {
  content: "";
  position: absolute;
  left: 0.9rem;
  top: 5px;
  width: 12px;
  height: 12px;
  border: 1px solid;
  border-color: #333333 transparent transparent #333333;
  transform: rotate(-45deg);
}
</style>



// WEBPACK FOOTER //
// src/pages/layer2/user/purchase.vue